import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState, useCallback, useMemo } from "react";
import CustomGridToolbar from "../../../../components/datagrid/GridToolBar";
import Terms from "./Terms";

const TermOptionView = React.memo(({ data }) => {
  const [gridSize, setGridSize] = useState(10);

  const columns = useMemo(
    () => [
      {
        field: "serialNumber",
        headerName: "SlNo",
        width: 60,
      },
      {
        field: "NoOfSessions",
        headerName: "No Of Sessions",
        width: 250,
      },
      {
        field: "amount",
        headerName: "Amount",
        width: 300,
      },
      {
        field: "amountAed",
        headerName: "Amount Aed",
        width: 250,
      },
      {
        field: "discount",
        headerName: "Check Discount",
        width: 250,
        renderCell: (params) => <Terms terms={params.row.options} />,
      },
    ],
    []
  );

  const rows = useMemo(() => {
    return (
      data?.options?.map((list, index) => ({
        ...list,
        serialNumber: index + 1,
      })) || []
    );
  }, [data]);

  const handlePageSizeChange = useCallback((newGridSize) => {
    setGridSize(newGridSize);
  }, []);

  return (
    <Box>
      <DataGrid
        components={{ Toolbar: CustomGridToolbar }}
        rows={rows}
        columns={columns}
        getRowId={(row) => row.priceId}
        pageSize={gridSize}
        autoHeight
        rowsPerPageOptions={[5, 10, 25, 50]}
        onPageSizeChange={handlePageSizeChange}
      />
    </Box>
  );
});

export default TermOptionView;
